// Module
var code = "<template id=\"paperbar-work-template\"> <div class=\"paperbar__works__work\"> <div class=\"paperbar__works__work__image\"></div> </div> </template> ";
// Exports
export default code;